import validate from "/app/node_modules/nuxt/dist/pages/runtime/validate.js";
import auth from "/app/modules/auth/runtime/middleware/auth.ts";
export const globalMiddleware = [
  validate,
  auth
]
export const namedMiddleware = {}